var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121.535,
    height: 35.863,
    viewBox: "0 0 121.535 35.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.d,.e,.f,.g,.h,.i,.j{fill-rule:evenodd;}.b,.c,.j{fill:#fff;}.d{fill:url(#a);}.e{fill:url(#b);}.f{fill:url(#c);}.g{fill:url(#d);}.h{opacity:0.2;}.i{opacity:0.12;}.j{opacity:0.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.472,
    y1: 1.035,
    x2: 2.361,
    y2: 1.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.95,
    y1: 1.879,
    x2: 1.69,
    y2: 1.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.926,
    y1: 0.946,
    x2: 1.835,
    y2: 0.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1.856,
    y1: 2.093,
    x2: 1.897,
    y2: 2.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1388.269 -23)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M117.032,35.863H4.5A4.505,4.505,0,0,1,0,31.38V4.483A4.5,4.5,0,0,1,4.5,0H117.032a4.5,4.5,0,0,1,4.5,4.483v26.9A4.507,4.507,0,0,1,117.032,35.863Z",
    transform: "translate(1388.269 23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1681.338,277.1a2.729,2.729,0,0,1-2.037-.843,2.87,2.87,0,0,1-.823-2.057,2.807,2.807,0,0,1,.823-2.055,2.72,2.72,0,0,1,2.035-.843,2.757,2.757,0,0,1,2.037.843,2.977,2.977,0,0,1,0,4.109A2.706,2.706,0,0,1,1681.338,277.1Zm-24.149,0a2.83,2.83,0,0,1-2.046-.832,2.9,2.9,0,0,1,2.046-4.963,2.85,2.85,0,0,1,1.143.237,2.311,2.311,0,0,1,.87.622l.054.065-.606.595-.063-.074a1.722,1.722,0,0,0-1.406-.606,1.944,1.944,0,0,0-1.4.572,2.173,2.173,0,0,0,0,2.978,2.049,2.049,0,0,0,2.842,0,1.547,1.547,0,0,0,.411-.932h-1.943v-.836h2.777l.011.076a3.083,3.083,0,0,1,.04.42,2.517,2.517,0,0,1-.693,1.856A2.705,2.705,0,0,1,1657.189,277.1Zm32.109-.119h-.856l-2.623-4.2.022.756v3.439h-.856v-5.556h.977l.027.042,2.466,3.953-.022-.754v-3.242h.865Zm-14.394,0h-.867v-4.722h-1.5v-.836h3.875v.836H1674.9v4.722Zm-3.079,0h-.865v-5.558h.865Zm-4.863,0h-.865v-4.722h-1.5v-.836h3.875v.836h-1.5Zm-2.918-.009h-3.318v-5.549h3.318v.836h-2.451v1.525h2.211v.827h-2.211v1.525h2.451Zm15.892-1.29a1.915,1.915,0,0,0,1.4.581,1.866,1.866,0,0,0,1.4-.581,2.2,2.2,0,0,0,0-2.96,1.919,1.919,0,0,0-1.4-.581,1.858,1.858,0,0,0-1.4.581,2.207,2.207,0,0,0,0,2.96Z",
    transform: "translate(-229.044 -242.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1670.968,687.235a3.814,3.814,0,1,0,3.825,3.814A3.755,3.755,0,0,0,1670.968,687.235Zm0,6.117a2.318,2.318,0,1,1,2.151-2.312A2.207,2.207,0,0,1,1670.968,693.352Zm-8.347-6.117a3.814,3.814,0,1,0,3.825,3.814A3.755,3.755,0,0,0,1662.622,687.235Zm0,6.117a2.318,2.318,0,1,1,2.151-2.312A2.207,2.207,0,0,1,1662.622,693.352Zm-9.931-4.952v1.614h3.874a3.4,3.4,0,0,1-.876,2.032,3.954,3.954,0,0,1-2.99,1.185,4.3,4.3,0,0,1,0-8.608,4.137,4.137,0,0,1,2.918,1.156l1.145-1.145a5.63,5.63,0,0,0-4.054-1.634,5.919,5.919,0,1,0,0,11.836,5.418,5.418,0,0,0,4.134-1.663,5.355,5.355,0,0,0,1.4-3.785,5.007,5.007,0,0,0-.089-1.006h-5.469S1652.69,688.4,1652.69,688.4Zm40.622,1.256a3.544,3.544,0,0,0-3.266-2.43,3.624,3.624,0,0,0-3.6,3.814,3.728,3.728,0,0,0,3.785,3.814,3.786,3.786,0,0,0,3.177-1.693l-1.295-.867a2.169,2.169,0,0,1-1.874,1.055,1.948,1.948,0,0,1-1.853-1.156l5.1-2.113S1693.313,689.656,1693.313,689.656Zm-5.2,1.275a2.093,2.093,0,0,1,1.992-2.223,1.47,1.47,0,0,1,1.415.807Zm-4.143,3.7h1.675V683.42h-1.675Zm-2.75-6.544h-.06a2.642,2.642,0,0,0-2.012-.856,3.814,3.814,0,0,0,0,7.622,2.634,2.634,0,0,0,2.012-.867h.06v.548c0,1.456-.778,2.24-2.032,2.24a2.114,2.114,0,0,1-1.923-1.355l-1.455.608a3.64,3.64,0,0,0,3.376,2.251c1.963,0,3.627-1.156,3.627-3.975v-6.844h-1.583v.628Zm-1.923,5.27a2.319,2.319,0,0,1,0-4.621,2.144,2.144,0,0,1,2.032,2.321A2.118,2.118,0,0,1,1679.3,693.352Zm21.857-9.932h-4v11.206h1.674v-4.244h2.332a3.486,3.486,0,1,0,0-6.962Zm.049,5.4h-2.381v-3.846h2.381a1.923,1.923,0,1,1,0,3.846Zm10.341-1.6a3.154,3.154,0,0,0-2.989,1.713l1.485.617a1.592,1.592,0,0,1,1.525-.827,1.617,1.617,0,0,1,1.764,1.444v.118a3.753,3.753,0,0,0-1.744-.429c-1.6,0-3.229.876-3.229,2.52a2.59,2.59,0,0,0,2.779,2.471,2.357,2.357,0,0,0,2.131-1.1h.06v.867h1.615V690.32C1714.94,688.321,1713.455,687.215,1711.544,687.215Zm-.21,6.137c-.547,0-1.315-.268-1.315-.957,0-.867.957-1.2,1.773-1.2a2.907,2.907,0,0,1,1.525.378A2.016,2.016,0,0,1,1711.333,693.352Zm9.5-5.9-1.923,4.861h-.06l-1.992-4.861h-1.8l2.99,6.795-1.7,3.776h1.744l4.6-10.571Zm-15.074,7.173h1.675V683.42h-1.675Z",
    transform: "translate(-221.614 -644.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M400.509,299.46a1.816,1.816,0,0,0-.409,1.266v19.825a1.728,1.728,0,0,0,.418,1.254l.069.06L411.7,310.758v-.248L400.579,299.4Z",
    transform: "translate(997.114 -269.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M922,638.169l-3.7-3.7V634.2l3.7-3.7.081.049,4.382,2.491c1.254.706,1.254,1.874,0,2.589l-4.382,2.491Z",
    transform: "translate(490.5 -593.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M433.362,805.785,429.577,802,418.4,813.177a1.467,1.467,0,0,0,1.862.06l13.1-7.452",
    transform: "translate(979.224 -761.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M433.362,294.221l-13.1-7.441a1.453,1.453,0,0,0-1.862.06l11.177,11.166Z",
    transform: "translate(979.224 -257.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M433.673,967.7l-13.01,7.392a1.476,1.476,0,0,1-1.793.009l-.069.069.069.06a1.479,1.479,0,0,0,1.793-.009l13.1-7.441Z",
    transform: "translate(978.832 -923.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1087.974,803.165l-4.474,2.54.08.08,4.382-2.491A1.57,1.57,0,0,0,1088.9,802,1.612,1.612,0,0,1,1087.974,803.165Z",
    transform: "translate(328.994 -761.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M402.372,286.739l17.482,9.932a1.648,1.648,0,0,1,.937,1.165,1.57,1.57,0,0,0-.937-1.295l-17.482-9.932c-1.254-.718-2.272-.119-2.272,1.315v.13C400.1,286.619,401.117,286.031,402.372,286.739Z",
    transform: "translate(997.114 -256.905)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.7adfa60c87ddf918308dfabc4ef98350.svg";
export { ForwardRef as ReactComponent };